import { DeferredRender } from "@/components/DeferedRender/DeferedRender";
import { NotAvailableOnMobile } from "@/components/NotAvailableOnMobile/NotAvailableOnMobile";
import { TrialEndWarning } from "@/components/TrialEndWarning/TrialEndWarning";
import { LayoutWorkstationFullscreen } from "@/components/_layouts/LayoutWorkstationFullscreen/LayoutWorkstationFullscreen";
import { LayoutWorkstationHeader } from "@/components/_layouts/LayoutWorkstationHeader/LayoutWorkstationHeader";
import { useableFreeCashFlowMolecule } from "@/financeModels/owasco/projections";
import { totalInvestorDistributionsTotalAtom } from "@/financeModels/owasco/returnMetrics";
import { getCurrentFinancialDeckEntity } from "@/models/financialDecks";
import { setFallbackCurrency } from "@/utils/moneyFormating";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useAsyncCallback } from "react-async-hook";
import { Outlet } from "react-router-dom";
import { Header } from "./Header/Header";
import { LoadingSpinner } from "./Loader";
import { ModelLoadError } from "./ModelLoadError";
import { SignupDazzler } from "./SignupDazzler";
import { WelcomeVideo } from "./WelcomeVideo";

export const ModelPage = () => {
  const deckEntity = getCurrentFinancialDeckEntity();

  // load expensive atoms to prime the cache
  //useAtomValue(sbaLoanAmortizationPaymentsAtom);
  useAtomValue(useableFreeCashFlowMolecule);
  useAtomValue(totalInvestorDistributionsTotalAtom);

  const {
    loading,
    execute: hydrate,
    result,
    error,
  } = useAsyncCallback(deckEntity.hydrate);

  useEffect(() => {
    hydrate();
  }, []);

  if (error) {
    return <ModelLoadError />;
  }

  if (result && !loading) setFallbackCurrency(result.currencyCode);

  return (
    <>
      {loading && <LoadingSpinner />}
      <LayoutWorkstationFullscreen>
        <TrialEndWarning>
          <LayoutWorkstationHeader header={<Header />}>
            <Outlet />
          </LayoutWorkstationHeader>
          <WelcomeVideo />
          <DeferredRender>
            <SignupDazzler />
            <NotAvailableOnMobile />
          </DeferredRender>
        </TrialEndWarning>
      </LayoutWorkstationFullscreen>
    </>
  );
};
